<template>
  <v-card v-if="user">
    <!-- <v-card> -->
    <slot name="title">
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">{{ title }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <div class="mr-4 d-flex justify-between">
          <v-btn color="primary" @click="isAdding = true">
            offers
            <v-icon class="ml-2" color="light-blue lighten-4"> mdi-account-money</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn color="primary" class="ml-2" @click="isMerging = true"> Initiate a merge </v-btn>
        </div>

        <v-spacer></v-spacer>
        <user-menu
          :user.sync="user"
          @update:user="$emit('update:dataUser', $event)"
          v-if="!hideActions"
        />
      </v-toolbar>
    </slot>

    <v-card-text>
      <v-row>
        <v-col lg="3" md="4" xs="12" sm="6" cols="12">
          <key-value title="Id">
            <span class="small" v-text="user.id"></span>
          </key-value>
          <key-value title="User Balance(EUR)" :value="'€' + user.balance_in_euro" />
          <key-value title="Payment Reference Number">
            <span class="small" v-text="user.payment_reference_number"></span>
          </key-value>
          <key-value title="First Name" :value="user.first_name" />
          <key-value title="Last Name" :value="user.last_name" />
          <key-value title="Date of birth" :value="user.birth_date" type="none" />
          <key-value title="Birth Place" :value="user.birth_city" />
          <key-value title="Birth Country" :value="user.birth_country" />
        </v-col>

        <v-col lg="3" md="4" xs="12" sm="6" cols="12">
          <key-value title="Phone Number" :value="user.full_phone_number" />
          <key-value title="Email">
            <span v-text="user.email"></span>
          </key-value>
          <key-value title="Address" :value="user.address_line" />
          <key-value title="City" :value="user.city" />
          <key-value title="Country" :value="user.country" />
          <key-value title="Gender" :value="user.gender" />
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Sending Country List</h4>
            <div v-if="isuserSendingCountriesFetching">
              <v-progress-circular size="20" color="primary" indeterminate></v-progress-circular>
            </div>
            <div
              v-if="
                userSendingCountries &&
                userSendingCountries.length > 0 &&
                !isuserSendingCountriesFetching
              "
            >
              <div v-for="country in userSendingCountries" :key="country.id">
                <h4>{{ country.name }}</h4>
              </div>
            </div>
            <div
              v-if="
                !isuserSendingCountriesFetching &&
                userSendingCountries &&
                userSendingCountries.length < 1
              "
              class="body-1 font-weight-medium"
            >
              N/A
            </div>
          </div>
          <key-value v-if="user.client" title="User Type" :value="user.client.type" />
          <key-value v-else title="User Type" value="" />
          <key-value title="Is Influencer">
            <v-icon color="success" size="25" v-if="user.is_influencer">mdi-progress-check</v-icon>
            <v-icon color="warning" size="25" v-else>mdi-progress-alert</v-icon>
          </key-value>
        </v-col>

        <v-col lg="3" md="4" xs="12" sm="6" cols="12">
          <h4 class="subtitle-2 font-weight-medium">User Offers</h4>
          <div v-if="user.associated_offers && user.associated_offers.length > 0">
            <div v-for="associatedoffer in user.associated_offers" :key="associatedoffer.id">
              <div class="d-flex align-center mt-2">
                <div>{{ associatedoffer.offer.name }}</div>
                <!-- <key-value :value="associatedoffer.offer.name" /> -->
                <v-btn
                  small
                  color="red"
                  icon
                  class="align-items-center red--text"
                  @click="deleteThisOffer(associatedoffer)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <div v-else>No offers</div>
          <br />
          <key-value title="Is white list">
            <h3 class="success--text" v-if="user.is_white_listed">TRUE</h3>
            <h3 class="error--text" v-else>FALSE</h3>
          </key-value>
          <h4 class="subtitle-2 font-weight-medium">User referral code</h4>
          <div v-if="user.default_campaign_referral_code">
            <div class="d-flex align-center mt-2">
              <div>{{ user.default_campaign_referral_code }}</div>
            </div>
          </div>
          <div v-else>N/A</div>
          <br />
          <template v-if="user.default_campaign_referral_code">
            <h4 class="subtitle-2 font-weight-medium">User Referral Code Alias</h4>
            <div v-if="user.referralCodeAlias">
              <div class="d-flex align-center mt-2">
                <div>{{ user.referralCodeAlias }}</div>
              </div>
            </div>
            <div v-else>
                <v-btn
                  small
                  icon
                  class="align-items-center primary--text"
                  @click="isAddingReferralCodeAlias = true"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <template></template>
              </div>
              <br />
          </template>
          <key-value v-if="isDistributor" title="Location" type="currency" :value="user.location" />
          <key-value title="Verification Result" :value="user.verification_result" />
          <key-value title="Verification Status">
            <h3 class="success--text" v-if="user.is_verified">VERIFIED</h3>
            <h3 class="error--text" v-else-if="normalizedVerificationResult === 'red-final'">REJECTED</h3>
            <h3 class="warning--text" v-else>PENDING</h3>
          </key-value>
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Rejection Labels</h4>

            <div v-if="user.on_boarding_review_result !== null">
              <div
                v-for="rejectLabel in user.on_boarding_review_result.rejectLabels"
                :key="rejectLabel.id"
              >
                <span class="small"> - {{ rejectLabel }}</span>
              </div>
              <key-value
                title="Client Comment"
                class="mt-4"
                value="user.on_boarding_review_result.clientComment"
              >
                <span class="small" v-text="user.on_boarding_review_result.clientComment"></span>
              </key-value>
              <key-value title="Rejection Detailed Comment">
                <span
                  class="small"
                  v-text="user.on_boarding_review_result.moderationComment"
                ></span>
              </key-value>
            </div>
            <div v-else>N/A</div>
          </div>
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Activation date</h4>
            <div v-if="user.activated_at !== null">
              <div>
                <span
                  :class="{
                    'success--text': user.activation_scoring === 'GREEN',
                    'red--text': user.activation_scoring === 'RED',
                    'orange--text': user.activation_scoring === 'YELLOW',
                  }"
                >
                  {{ user.activated_at }}
                </span>
              </div>
            </div>
            <div v-else>N/A</div>
          </div>
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Automatic activation</h4>
            <div v-if="user.activated_at !== null">
              <div>
                <span> {{ user.is_auto_activated ? "TRUE" : "FALSE" }}</span>
              </div>
            </div>
            <div v-else>N/A</div>
          </div>
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Activation scoring</h4>
            <div v-if="user.activation_scoring !== null">
              <div>
                <span
                  class="font-weight-black body-1"
                  :class="{
                    'success--text': user.activation_scoring === 'GREEN',
                    'red--text': user.activation_scoring === 'RED',
                    'orange--text': user.activation_scoring === 'YELLOW',
                  }"
                >
                  {{ user.activation_scoring }}
                </span>
              </div>
            </div>
            <div v-else>N/A</div>
          </div>
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Compliance Risk Scoring</h4>
            <div v-if="user.compliance_score !== null">
              <div>
                <span
                  class="font-weight-black body-1"
                  :class="{
                    'success--text': /GREEN/.test(user.compliance_risk_scoring),
                    'red--text': /RED/.test(user.compliance_risk_scoring),
                  }"
                >
                  {{ user.compliance_risk_scoring }}
                </span>
              </div>
            </div>
            <div v-else>N/A</div>
          </div>
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">SumSub IP Check Scoring</h4>
            <div v-if="user.sumsub_ipcheck !== null">
              <div>
                <span
                  class="font-weight-black body-1"
                  :class="{
                    'success--text': user.sumsub_ipcheck === 'GREEN',
                    'red--text': user.sumsub_ipcheck === 'RED',
                  }"
                >
                  {{ user.sumsub_ipcheck }}
                </span>
              </div>
            </div>
            <div v-else>N/A</div>
          </div>
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Internal IP Check Scoring</h4>
            <div v-if="user.internal_ipcheck !== null">
              <div>
                <span
                  class="font-weight-black body-1"
                  :class="{
                    'success--text': user.internal_ipcheck === 'GREEN',
                    'red--text': user.internal_ipcheck === 'RED',
                    'orange--text': user.internal_ipcheck === 'YELLOW',
                  }"
                >
                  {{ user.internal_ipcheck }}
                </span>
              </div>
            </div>
            <div v-else>N/A</div>
          </div>
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Naming score</h4>
            <div v-if="user.naming_score !== null">
              <div>
                <span
                  class="font-weight-black body-1"
                  :class="{
                    'success--text': user.naming_score === 'GREEN',
                    'red--text': user.naming_score === 'RED',
                    'orange--text': user.naming_score === 'YELLOW',
                  }"
                >
                  {{ user.naming_score }}
                </span>
              </div>
            </div>
            <div v-else>N/A</div>
          </div>
          <key-value title="Activation status">
            <span class="font-weight-black body-1" :class="userActivationClass">
              {{ user.activation_scoring }}
            </span>
          </key-value>
        </v-col>

        <!-- new values -->

        <v-col>
          <key-value title="Residency Type" :value="user.residency" />
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Job</h4>
            <div v-if="isJobFetching">
              <v-progress-circular size="20" color="primary" indeterminate></v-progress-circular>
            </div>
            <h2 v-else class="body-1 font-weight-medium">
              {{ computedUserJob }}
            </h2>
          </div>
          <key-value title="Origin" :value="computedUserOrigin" />
          <key-value title="Monthly Revenue" :value="computedUserMonthlyRevenue" />
          <key-value title="User Balance(EUR)" :value="'€' + user.balance_in_euro" />
          <key-value title="Origin" :value="computedUserOrigin" />

          <key-value title="Residency Type" :value="user.residency" />
          <div class="mb-5">
            <h4 class="subtitle-2 font-weight-medium">Job</h4>
            <div v-if="isJobFetching">
              <v-progress-circular size="20" color="primary" indeterminate></v-progress-circular>
            </div>
            <h2 v-else class="body-1 font-weight-medium">
              {{ computedUserJob }}
            </h2>
          </div>

          <div v-if="userActivites && userActivites.length > 0">
            <h4>Activities</h4>
            <div v-for="activity in userActivites" :key="activity.id">
              <div>{{ activity.name }}</div>
            </div>
          </div>
          <key-value title="Monthly Revenue" :value="computedUserMonthlyRevenue" />
        </v-col>
      </v-row>
    </v-card-text>
    <user-referral-code-alias :is-active.sync="isAddingReferralCodeAlias" :user="user" @changed="addingReferralCode" />
    <user-offer :is-active.sync="isAdding" :user="user" @changed="offerAdded" />
    <user-merge :is-active.sync="isMerging" :user="user" @changed="mergeInitiated" />
    <user-referral-code-alias :is-active.sync="isAddingReferralCodeAlias" :user="user" @changed="addingReferralCode" />
  </v-card>
</template>
<script>
import UserMenu from "./userMenu";
import UserOffer from "./userOffer.vue";
import UserMerge from "./userMerge.vue";
import UserReferralCodeAlias from "./userReferralCodeAlias.vue";
export default {
  components: { UserMenu, UserOffer, UserMerge, UserReferralCodeAlias },
  props: {
    dataUser: Object,
    title: { default: "User details" },
    hideActions: { type: Boolean, default: false },
  },
  data() {
    return {
      isAddingReferralCodeAlias: false,
      isAdding: false,
      isMerging: false,
      user: this.dataUser,
      userSendingCountries: [],
      isuserSendingCountriesFetching: true,
      userActivites: [],
      userActivity: null,
      userMonthlyRevenue: "-",
      isJobFetching: true,
      isDistributor:
        this.dataUser.client &&
        this.dataUser.client.type.toLocaleLowerCase().includes("distributor"),
    };
  },

  created() {
    // get individual envisioned countries and activities if job is null
    this.$http
      .get(`api/v1/users/${this.user.id}/envisioned-receiving-countries`)
      .then((response) => {
        if (
          response["receiving-countries"] &&
          Array.isArray(response["receiving-countries"]) &&
          response["receiving-countries"].length > 0
        ) {
          this.userSendingCountries = response["receiving-countries"];
        }
      })
      .finally(() => (this.isuserSendingCountriesFetching = false));
    if (
      this.user.activity_id !== undefined &&
      this.user.activity_id !== null &&
      this.user.activity_id !== ""
    ) {
      this.$http
        .get(`/api/v1/individual-activities/${this.user.activity_id}`)
        .then((response) => {
          if (response.name !== undefined) {
            this.userActivity = response.name;
          }
        })
        .finally(() => (this.isJobFetching = false));
    } else {
      this.isJobFetching = false;
    }
  },

  methods: {
    offerAdded() {
      this.$emit("syncOffer");
      this.isAdding = false;
    },
    addingReferralCode({ message }){
      this.$emit("syncOffer");
      this.isAddingReferralCodeAlias = false;
      Notify.success(message);
    },
    mergeInitiated({ message }) {
      this.isMerging = false;
      Notify.success(message);
    },
    async deleteThisOffer(offer) {
      const id = offer.id;
      await Notify.confirm(`Do you want to detach this Offer?`).then(() => {
        this.$http
          .delete(`/api/v1/userOffer/${id}/detach`)
          .then((result) => {
            Notify.success(result.message);
            this.$emit("syncOffer");
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
    async fetchUserActivites(user_id) {
      this.$http
        .get(`/api/v1/users/individual-activities/${user_id}`)
        .then((response) => {
          this.userActivites = response.data;
        })
        .catch((error) => {
          Notify.error(error.message);
        });
    },
  },

  watch: {
    dataUser(newUserData) {
      return (this.user = newUserData);
    },
  },

  computed: {
    computedUserMonthlyRevenue() {
      if (this.user.monthly_revenue == null || this.user.monthly_revenue == undefined) {
        return "Not Specified";
      } else {
        return this.user.monthly_revenue.replaceAll(/-/gi, "to");
      }
    },
    computedUserOrigin() {
      if (
        this.user.meta.user_origin == null ||
        this.user.meta.user_origin == undefined ||
        Array.isArray(this.user.meta.user_origin)
      ) {
        return "Not Specified";
      } else {
        return this.user.meta.user_origin;
      }
    },
    computedUserJob() {
      if (this.user.job == null || this.user.job == undefined) {
        if (this.userActivity !== null) {
          return this.userActivity;
        } else {
          return "Not Specified";
        }
      } else {
        return this.user.job;
      }
    },
    userActivationClass() {
      const { is_active, activation_scoring, internal_ipcheck } = this.user;

      return {
        "success--text": is_active && activation_scoring === "GREEN",
        "red--text": !is_active && activation_scoring === "RED",
        "orange--text": internal_ipcheck === "YELLOW",
      };
    },
    normalizedVerificationResult() {
      return this.user && this.user.verification_result 
      ? this.user.verification_result.toLowerCase() 
      : '';
    }
  },
};
</script>
